import EventEmitter from 'eventemitter3';

export enum RECORDER_EVENTS {
    SCREEN_SHARING_STOPPED = 'SCREEN_SHARING_STOPPED',
}

export const RecorderEventEmitter = new EventEmitter();
